import "./sass/main.scss";

import "./js/contacts-modal.js";
import "./js/map.js";
import "./js/modal-about.js";
import "./js/mobile-menu.js";
